import { Platform } from 'react-native';
import { useAuthStore, useModalStore } from '@/store';
import { router } from 'expo-router';

/**
 * Gate Voice Mode behind Gab AI Plus.
 * On native, opens the IAP paywall; on web, opens PricingModal.
 * @param {{ title?: string, subtitle?: string }} [opts]
 * @returns {boolean} true if the user can start voice mode
 */
export function requirePlusForVoice(opts = {}) {
  const isPlus = !!useAuthStore.getState().user?.flags?.isPlus;
  if (isPlus) return true;

  const title = opts.title || 'Plus required';
  const subtitle = opts.subtitle || 'Voice Mode requires Gab AI Plus.';

  // Native apps use the dedicated IAP paywall screen (PricingModal redirects
  // there too, but pushing directly avoids a blank modal flash).
  if (Platform.OS === 'ios' || Platform.OS === 'android' || Platform.OS === 'macos') {
    router.push('/(auth)/paywall');
    return false;
  }

  const { openModal } = useModalStore.getState().actions;
  openModal('PricingModal', { title, subtitle });
  return false;
}
